import {
  FETCH_INVOICEDETAILS_REQUEST,
  FETCH_INVOICEDETAILS_SUCCESS,
  FETCH_INVOICEDETAILS_FAILURE,
} from "./invoiceDetailsTypes";

const initialState = {
  loading: false,
  invoiceDetails: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVOICEDETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_INVOICEDETAILS_SUCCESS:
      return {
        loading: false,
        invoiceDetails: action.payload,
        error: "",
      };
    case FETCH_INVOICEDETAILS_FAILURE:
      return {
        loading: false,
        invoiceDetails: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
